/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./styles/InputField.module.css";
import cn from "classnames";
import { ReactNode, forwardRef } from "react";
import { Warning as IconWarning } from "phosphor-react";

type Size = "S" | "M" | "L";

type Style = "contained" | "outlined";

interface Props {
  size: Size;
  style: Style;
  placeholder: string;
  onChange: (event?: any) => void;
  value: string;
  label?: ReactNode; // This can come with only text, but with an icon as well
  disabled?: boolean;
  hint?: ReactNode; // This can come with only text, but with an icon as well
  error?: string;
  prefix?: ReactNode;
  containerClassName?: string;
  inputType?: "text" | "number";
  maxLength?: number;
}
export const InputField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    size,
    style,
    placeholder,
    label,
    value,
    hint,
    disabled,
    error,
    prefix,
    onChange,
    inputType = "text",
    maxLength,
    containerClassName,
    ...nativeProps
  } = props;

  return (
    <div>
      {label && (
        <label htmlFor={value} className={styles.label}>
          {label}
        </label>
      )}
      <div
        className={cn(
          styles.input,
          styles[`size-${size}`],
          styles[`style-${style}`],
          disabled && styles.disabled,
          error && styles.inputError,
          containerClassName
        )}
      >
        {prefix && <span className={styles.prefix}>{prefix}</span>}
        <input
          id={value}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          type={inputType}
          disabled={disabled}
          maxLength={maxLength}
          ref={ref}
          {...nativeProps}
        />
      </div>
      {error && (
        <div className={styles.error} role="alert">
          <IconWarning />
          {error}
        </div>
      )}
      {hint && (
        <div className={styles.hint} aria-describedby="value">
          {hint}
        </div>
      )}
    </div>
  );
});
